var target = document.querySelector('body');
var config = { childList: true, subtree: true };

var callback = function(mutationsList, observer) {
    for(var mutation of mutationsList) {
        if (mutation.addedNodes.length && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('ReactModalPortal')) {
            /* CHANGE DOM FOR ALMA POPUP DESKTOP */
            let titleContainer = $('.alma-eligibility-modal-desktop-modal');
            let title = $('.alma-eligibility-modal-desktop-modal .alma-eligibility-modal-title');

            if (titleContainer.length > 0 && title.length > 0) {
                // remove "." at end of line
                title[0].textContent = title[0].textContent.replace(/\.$/, "");
                // move title into container
                titleContainer.before(title);
            }

            let logoContainer = $('.alma-eligibility-modal-right-side');
            let logo = $('.alma-eligibility-modal-left-side > svg');

            if (logoContainer.length > 0 && logo.length > 0) {
                // move logo into container
                logoContainer.prepend(logo);
            }
        }
    }
}

var observer = new MutationObserver(callback);
observer.observe(target, config);